module.exports = __webpack_public_path__ + "media/James_Newton_Howard_Ft._Jennifer_Lawrence-The_Hanging_Tree-320k.79c1465c.mp3";